import { Status, Wrapper } from '@googlemaps/react-wrapper';
import { FunctionComponent, ReactElement, RefObject, useEffect, useRef } from 'react';
import styled from 'styled-components';

const MapField = styled.div`
  margin-bottom: 10px;
`;

const render = (status: Status): ReactElement => {
  if (status === Status.LOADING) return <h3>{status} ..</h3>;
  if (status === Status.FAILURE) return <h3>{status} ...</h3>;
  return null as any;
};

function MapComponent({
  center: centerProp,
  zoom,
  onClick,
}: {
  center: google.maps.LatLngLiteral;
  zoom: number;
  onClick?: (coord: google.maps.LatLngLiteral) => void;
}) {
  const ref = useRef<HTMLDivElement>() as RefObject<HTMLDivElement>;
  const mapRef = useRef<google.maps.Map>();
  const markerRef = useRef<google.maps.Marker>(new google.maps.Marker());

  useEffect(() => {
    const map = new window.google.maps.Map(ref.current!, {
      fullscreenControl: false,
      streetViewControl: false,
      zoomControl: false,
      mapTypeControl: false,
    });

    map.addListener('click', async event => {
      const { lat: latitude, lng: longitude } = event.latLng;
      const lat = await latitude();
      const lng = await longitude();
      onClick?.({ lat, lng });
    });
    mapRef.current = map;
    // TO DO try to wrap onClick in useCallback
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const map = mapRef.current!;
    const lat = centerProp.lat;
    const lng = centerProp.lng;
    map.setCenter({ lat, lng });
    map.setZoom(zoom);
    const center: google.maps.LatLngLiteral = {
      lat,
      lng,
    };

    const marker = markerRef.current;
    marker.setPosition(center);
    marker.setMap(map);
  }, [centerProp.lat, centerProp.lng, zoom]);

  return <div style={{ height: '500px', width: 'auto' }} ref={ref} id="map" />;
}

interface MapProps {
  lat: number;
  lng: number;
  zoom: number;
  onClick?: (coord: google.maps.LatLngLiteral) => void;
}

export const Map: FunctionComponent<MapProps> = props => {
  const { lat, lng, zoom, onClick } = props;
  const center = { lat, lng };

  return (
    <MapField>
      <Wrapper apiKey={process.env.GOOGLE_MAPS_API_KEY!} render={render}>
        <MapComponent center={center} zoom={zoom} onClick={onClick} />
      </Wrapper>
    </MapField>
  );
};
